<template>
  <div>
    <div class="section1-container">
      <div class="box-wrapper">
        <div class="row m-0">
          <div class="col-12 box-wrapper-col">
            <div class="title">{{ $t("message.contact.title[0]") }}</div>
            <div class="content">
              <div class="row m-0">
                <div class="col-12 col-md-4">
                  {{ $t("message.contact.address[0].title") }}
                  <i class="fas fa-map-marker-alt"></i>
                </div>
                <div class="col">
                  {{ $t("message.contact.address[0].text") }}
                </div>
              </div>
              <div class="row m-0">
                <div class="col-12 col-md-4">
                  {{ $t("message.contact.address[1].title") }}
                  <i class="fas fa-envelope"></i>
                </div>
                <div class="col">
                  {{ $t("message.contact.address[1].text") }}
                </div>
              </div>
              <div class="row m-0">
                <div class="col-12 col-md-4">
                  {{ $t("message.contact.address[2].title") }}
                  <i class="fas fa-phone-alt"></i>
                </div>
                <div class="col">
                  {{ $t("message.contact.address[2].text") }}
                </div>
              </div>
            </div>
            <div class="map mt-4">
              <div style="width: 100%">
                <iframe
                  width="100%"
                  src="https://maps.google.com/maps?width=100%&amp;height=600&amp;hl=en&amp;q=%E0%B8%9A%E0%B8%A3%E0%B8%B4%E0%B8%A9%E0%B8%B1%E0%B8%97%20%E0%B8%A1%E0%B8%B2%E0%B8%A2%E0%B8%B2%E0%B8%93%E0%B8%81%E0%B8%B2%E0%B8%99%E0%B8%95%E0%B9%8C%20%E0%B8%88%E0%B8%B3%E0%B8%81%E0%B8%B1%E0%B8%94+(%E0%B8%9A%E0%B8%A3%E0%B8%B4%E0%B8%A9%E0%B8%B1%E0%B8%97%20%E0%B8%A1%E0%B8%B2%E0%B8%A2%E0%B8%B2%E0%B8%93%E0%B8%81%E0%B8%B2%E0%B8%99%E0%B8%95%E0%B9%8C%20%E0%B8%88%E0%B8%B3%E0%B8%81%E0%B8%B1%E0%B8%94)&amp;ie=UTF8&amp;t=&amp;z=17&amp;iwloc=B&amp;output=embed"
                  frameborder="0"
                  scrolling="no"
                  marginheight="0"
                  marginwidth="0"
                ></iframe>
              </div>
              <br />
            </div>
            <div class="email">
              <div class="title">
                {{ $t("message.contact.title[1]") }}
              </div>
              <b-form @submit.prevent="sendEmail()">
                <div class="row m-0">
                  <div class="col-12 col-md-6">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <div class="input-group-text">
                          <i class="fas fa-user"></i>
                        </div>
                      </div>
                      <input
                        type="text"
                        class="form-control"
                        id="inlineFormInputGroup"
                        :placeholder="$t('message.contact.form[0]')"
                        name="name"
                        ref="name"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <div class="input-group-text">
                          <i class="fas fa-link"></i>
                        </div>
                      </div>
                      <input
                        type="text"
                        class="form-control"
                        id="inlineFormInputGroup"
                        :placeholder="$t('message.contact.form[1]')"
                        name="subject"
                        ref="subject"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <div class="input-group-text">
                          <i class="fas fa-envelope"></i>
                        </div>
                      </div>
                      <input
                        type="text"
                        class="form-control"
                        id="inlineFormInputGroup"
                        name="email"
                        :placeholder="$t('message.contact.form[2]')"
                        ref="email"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <div class="input-group-text">
                          <i class="fas fa-phone-alt"></i>
                        </div>
                      </div>
                      <input
                        type="text"
                        class="form-control"
                        id="inlineFormInputGroup"
                        name="phone"
                        :placeholder="$t('message.contact.form[3]')"
                        ref="phone"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-12 col-12">
                    <textarea
                      class="form-control"
                      id="exampleFormControlTextarea1"
                      name="text"
                      rows="6"
                      :placeholder="$t('message.contact.form[4]')"
                      ref="text"
                      required
                    ></textarea>
                  </div>
                </div>
                <div class="row m-0 text-center">
                  <div class="col-12">
                    <button type="submit" class="button">
                      {{ $t("message.contact.button") }}
                    </button>
                  </div>
                </div>
              </b-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    sendEmail() {
      let name = this.$refs.name.value.replace(/^\s+|\s+$/g, "");
      let subject = this.$refs.subject.value.replace(/^\s+|\s+$/g, "");
      let email = this.$refs.email.value.replace(/^\s+|\s+$/g, "");
      let phone = this.$refs.phone.value.replace(/^\s+|\s+$/g, "");
      let text = this.$refs.text.value.replace(/^\s+|\s+$/g, "");
      let body = `${name} | ${phone} %0D%0A "${text}"`;

      window.open(`mailto:${email}?subject=${subject}&body=${body}`);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@scss/contact/section1.scss";
</style>